<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="设备SN号">
          <Input placeholder="请输入" v-model="table.search.ClientSN"></Input>
        </FormItem>
        <FormItem label="设备名称">
          <Input placeholder="请输入" v-model="table.search.ClientName"></Input>
        </FormItem>
        <FormItem label="设备类型">
          <Input placeholder="请输入" v-model="table.search.ClientType"></Input>
        </FormItem>
      </Form>
      <!--操作区域-->
      <div>
        <Button class="mr-3" type="success" @click="search">查询</Button>
        <Button class="mr-3" type="primary" @click="addModal = true">新增</Button>
        <Button class="mr-3" type="warning" @click="deleteBatch">批量删除</Button>
      </div>

    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--新增-->
    <Modal
      v-model="addModal"
      title="新增设备"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientadd @close="addModal = false" @loadData="search"></clientadd>
    </Modal>

    <!--更新-->
    <Modal
      v-model="editModal"
      title="更新设备"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientedit
        v-if="editModal"
        @close="editModal = false"
        @loadData="search"
        :currentData="currentData"
      ></clientedit>
    </Modal>

    <!--详情-->
    <Modal
      v-model="detailModal"
      title="设备详情"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientdetail
        v-if="detailModal"
        @close="detailModal = false"
        :currentData="currentData"
      ></clientdetail>
    </Modal>
    <!--详情-->
    <Modal width="1200px" height="100"
      v-model="linkclientdetailModel"
      title="客户端详情"
      :footer-hide="true" 
      
      :closable="true"
    >
      <linkclientdetail 
        v-if="linkclientdetailModel"
        @close="linkclientdetailModel = false"
        :ClientId="ClientId"
      ></linkclientdetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import clientadd from "../client/add.vue";
import clientedit from "../client/edit.vue";
import clientdetail from "../client/detail.vue";
import linkclientdetail from "../clientDetail/list.vue";
export default {
  components: {
    DataTable,
    clientadd,
    clientedit,
    clientdetail,
    linkclientdetail,
  },
  data: function () {
    return {
      currentData: {},
      detailModal: false,
      addModal: false,
      editModal: false,
      ClientId:'',
      linkclientdetailModel: false,
      selectionData: [],
      table: {
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "设备SN码", key: "clientSN" },
          { title: "设备名称", key: "clientName" },
          { title: "设备类型", key: "clientType" },
          { title: "所属机构", key: "organName" },
          {
            title: "是否激活",
            key: "isActived",
            width: "80",
            render: (h, value) => {
              return h("div", value.row.isActived == "0" ? "否" : "是");
            },
          },
          {
            title: "操作",
            width: "300px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.lockedHandler(params.row);
                      },
                    },
                  },
                  params.row.isActived == "0" ? "激活" : "锁定"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.LookClientDetail(params.row);
                      },
                    },
                  },
                  "客户端"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.clientID);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        apiUrl: "client/getList",
        search: {
          ClientSN: "",
          ClientName: "",
          ClientType: "",
        },
      },
    };
  },

  activated(){
    this.search()
  },

  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },

    toAdd: function () {
      this.$router.push({ path: "departmentAdd" });
    },

    toEdit: function (data) {
      this.editModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },
    LookClientDetail: function (data) {
      this.linkclientdetailModel = true;
      this.ClientId = data.clientID;
    },

    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "会同步删除设备明细数据,是否继续？",
        mask: false,
        onOk: () => {
          this.$api.post(`/client/delete?id=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },

    //批量删除
    deleteBatch() {
      if (this.selectionData.length < 1) {
        this.$Message.warning("请先勾选数据");
      } else {
        let ids = [];
        this.selectionData.forEach((item) => {
          ids.push(item.clientID);
        });
        let _ids = ids.join(";");
        this.$Modal.confirm({
          title: "会同步删除设备明细数据,是否继续？",
          mask: false,
          onOk: () => {
            this.$api.post(`/client/deleteBatch?ids=${_ids}`).then((rsp) => {
              if (rsp != false) {
                this.$Message.success("删除成功");
                this.search();
              }
            });
          },
        });
      }
    },
    lockedHandler: function (data) {
      let temp = data.isActived == "0" ? "激活" : "锁定";
      this.$Modal.confirm({
        title: `确认要${temp}该设备吗？`,
        mask: false,
        onOk: () => {
          this.$api.post(`/client/locked?id=${data.clientID}`).then((rsp) => {
            this.$Message.success(`${temp}成功`);
            this.search();
          });
        },
      });
    },
    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>